import Button from '../components/Button'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import TextField from '../components/TextField'
import TextArea from '../components/TextArea'
import './Home.css'

import PhoneImage from '../images/phone.png'
import GlowImage from '../images/glow.png'
import GridImage from '../images/grid.png'
import RockhurstImage from '../images/rockhurst.png'
import KansasCityStarImage from '../images/kc-star.png'

/* Featured Resources Images */
import Healthcare from '../images/healthcare.png'
import Food from '../images/food.png'
import Employment from '../images/employment.png'

/* How It Works */
import Steps from '../images/steps.png'

/* Chat Now Button Clicked */
function buttonClicked() {
    window.location.href = "/chat"
}

/* Contact Form Submission */
async function submitContactForm() {
    const webhookBody = {
        embeds: [{
            title: 'Contact Form Submitted',
            description: `From: ${document.getElementById("user-email").value}\n\n${document.getElementById("user-message").value}`
        }]
        }
    
        /* SEND TICKET */
        const webhookURL = "https://discord.com/api/webhooks/1361049640459309246/YRZZJPDmhBm7TkpPBXbhi1Sii8u_3iDz5Trjms6J6mqeCfX8N5-735vFqnvVeG6Hew4q"
        const response = await fetch(webhookURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(webhookBody),
        });
        if (response.ok) {
            alert("We have received your message! We will try to get back to you shortly.")
            window.location.href = "/";
        } else {
            alert("There was an error submitting your contact form. Please notify admin@kcsocialnest.com.")
            window.location.href = "/";
        }   
}

/* Home XML */
export default function Home() {
    return (
        <div>
            <Navbar/>
            
            {/* Hero Content */}
            <div className="hero-content" style={{display:"flex", justifyContent: "space-around", height: "900px"}}>
                <div style = {{marginTop:"auto", marginBottom:"auto", display: "grid", rowGap: '30px'}}>
                    <h1 style = {{fontSize:"48px"}}>Your KC Health Expert</h1>
                    <p style = {{maxWidth: "600px", fontSize: '28px'}}>Instant access to valuable healthcare information, simplifying your healthcare journey with personalized, easy-to-understand advice.</p>
                    <Button text = "GET STARTED" onClick = {buttonClicked}/>
                </div>
                <div id = "phones" style = {{display: 'flex'}}>
                    <img src={PhoneImage} style = {{width: '700px', height: '800px', marginTop: '200px'}}></img>
                </div>
            </div>
            {/* <img src={GlowImage} className="glow" style = {{position:"absolute", width: "80vw", top: "-10vw", right: "-10vw", zIndex: -1}}></img> */}
            <img src = {GridImage} style = {{position:'absolute', width: '100vw', height: '100%', objectFit: 'cover', top: '0px', left: '0px', zIndex:-2, opacity: '5%'}}/>

            {/* As Seen On */}
            {/* <h1 style = {{textAlign:'center'}}>As seen on</h1>
            <div id="as-seen-on" style = {{display:'flex', flexWrap: 'wrap', columnGap:'60px', width: 'max-content', maxWidth: '90vw', marginLeft: 'auto', marginRight: 'auto', marginTop: '50px', marginBottom: '100px'}}>
                <img className = 'seen-on-image' src={RockhurstImage}/>
                <img className = 'seen-on-image' src={KansasCityStarImage}/>
            </div> */}

            {/* How It Works */}
            <div id = "how-it-works" style = {{textAlign: 'center'}}>
                <h1 style = {{textAlign: 'center'}}>How it Works</h1>
                <img src = {Steps} style = {{width: '800px', marginLeft: 'auto', marginRight: 'auto', maxWidth: '90vw', marginTop: '50px'}}></img>
            </div>

            {/* Featured Resources */}
            <div id = "featured-resources" style ={{marginTop: '100px'}}>
                <h1 style = {{textAlign: 'center'}}>Featured Resources</h1>
                <div style = {{display: 'flex', justifyContent: 'center', gap: '30px', flexWrap: 'wrap', marginTop: '30px', maxWidth: '100%'}}>
                    <div className = "featured-resource-card-wrapper">
                        <img className = "featured-resource-card" src = {Healthcare}></img>
                        <p>Healthcare</p>
                    </div>
                    <div className = "featured-resource-card-wrapper">
                        <img className = "featured-resource-card" src = {Food}></img>
                        <p>Food</p>
                    </div>
                    <div className = "featured-resource-card-wrapper">
                        <img className = "featured-resource-card" src = {Employment}></img>
                        <p>Employment</p>
                    </div>
                </div>
            </div>

            {/* Contact */}
            <div id = "contact" style = {{marginTop: '100px', marginBottom: '100px'}}>
                <h1 style = {{textAlign: 'center'}}>Questions?</h1>
                <div style = {{width: '400px', maxWidth: '90vw',  marginLeft: 'auto', marginRight: 'auto', marginTop: '30px'}}>
                    <p>Email Address</p>
                    <TextField inputId = "user-email" width = '400px' maxWidth = '90vw' placeholder="Email address"/>
                    <p style = {{marginTop: '10px'}}>Message</p>
                    <TextArea inputId = "user-message" placeholder = "Enter your message here"></TextArea>
                    <div style = {{marginTop: '20px'}}></div>
                    <Button text = "Submit" width = '400px' maxWidth = '90vw' onClick = {submitContactForm}></Button>
                </div>
            </div>
            <Footer/>
        </div>
    )
}